// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".buttonStyles-cls1__d140fe3bdeb65ac76bda{/*!*/}.buttonStyles-cls2___07f709d68d1bc127826{position:absolute;top:0;right:-8px;margin-left:4px;width:6px;height:6px;border-radius:50%;background:#bb0202}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "buttonStyles-cls1__d140fe3bdeb65ac76bda",
	"cls2": "buttonStyles-cls2___07f709d68d1bc127826 buttonStyles-cls1__d140fe3bdeb65ac76bda"
};
export default ___CSS_LOADER_EXPORT___;
